import * as z from 'zod/mini'
import { customerNoteField, endAfterStart, isoDateTime } from '../../schemas/common'
import { contactFields } from '../../schemas/contact'

/** A public reservation link (`reservations/:reservationId`). No login: a malformed id must be a 404, never a 500. */
export const publicReservationParams = z.object({ reservationId: z.uuid() })
export type PublicReservationParams = z.infer<typeof publicReservationParams>

/** `?t=` is the magic-link token from the confirmation email; without it the reservation is read-only. */
export const getPublicReservationQuery = z.object({
  t: z.optional(z.string()),
})
export type GetPublicReservationQuery = z.infer<typeof getPublicReservationQuery>

/**
 * A booking from the public widget. The ids are only shape-checked here; `PublicEntityReservationController`
 * resolves them within the premise (404 for an id from elsewhere). An omitted `placeId` or `employeeId`
 * means "any": the API assigns a free one.
 *
 * The two consents are the event sign-up's (`joinPublicEventBody`): `termsAgreed` must be `true`, and
 * `marketingConsent` only ever grants, never withdraws.
 */
export const joinPublicReservationBody = z
  .object({
    ...contactFields,
    /** "Poznámka pre prevádzku": stored only when the service allows it, dropped otherwise (a form loaded earlier). */
    note: z.optional(customerNoteField),
    reservationBlueprintId: z.uuid(),
    employeeId: z.optional(z.uuid()),
    placeId: z.optional(z.uuid()),
    startDateTime: isoDateTime,
    endDateTime: isoDateTime,
    termsAgreed: z.literal(true),
    marketingConsent: z.boolean(),
  })
  .check(z.superRefine(endAfterStart('startDateTime', 'endDateTime')))
export type JoinPublicReservationBody = z.infer<typeof joinPublicReservationBody>
